import { authService } from "../auth/auth";
import { GroupChangeEvent, groupContext } from "../context/group";
import { _APP_DATA } from "../data/AppData";
import { PhotoEventUploadPayload } from "../data/services/Photo";
import { DataUtilLocalStorage } from "../data/utils/LocalStorage";
import { PrivacyPolicyModal } from "../ui/components/PrivacyPolicyModal";
import { DBDelete } from "../data/utils/DB";
import { _CreateUUID, _DownloadFile } from "../data/utils/General";
import { _GetHashInfo, _LoadUIFromHash } from "../routes/Router";
import { THashPath } from "../routes/Routes";
import { _HashAssign, _HashReplace, OnHashChangeController } from "../routes/UIManager";
import { IMobileInsets, KeyboardSizeChangeEvent, MobileInsetChangeEvent } from "../types/CustomEvents";
import { LOADING } from "../ui/components/Loading";
import { ShowToast } from "../ui/components/Toast";
import { _PROXIMIDAD_CTRL } from "../ui/controllers/ProximidadController";

// ****************************************************************
// MOBILE DECLARACION
// ****************************************************************

export declare var Mobile: IMobile;

// ****************************************************************
// MOBILE FUNCIONES
// ****************************************************************

export function _IsMobileDevice() {
    return 'ontouchstart' in window;

    // if (navigator.userAgent.match(/Android/i)
    //     || navigator.userAgent.match(/webOS/i)
    //     || navigator.userAgent.match(/iPhone/i)
    //     || navigator.userAgent.match(/iPad/i)
    //     || navigator.userAgent.match(/iPod/i)
    //     || navigator.userAgent.match(/BlackBerry/i)
    //     || navigator.userAgent.match(/Windows Phone/i)
    // ) return true;
    // else return false;
}

export function _MobileObjectIsDefined() {
    return !!(window["Mobile"]);
}

export function _MobileObject() {
    if (!_MobileObjectIsDefined()) {
        return null;
    }
    return Mobile;
}

// ****************************************************************
// MOBILE IMPLEMENTACION
// ****************************************************************

export const _CURRENT_MOBILEKEYBOARD: KeyboardSizeChangeEvent["detail"] = {
    BodyTranslateY: 0,
    KeyboardHeight: 0
};
export const _IS_SAFARI_NAVIGATOR = !!navigator.vendor.match(/apple/i) &&
    !navigator.userAgent.match(/crios/i) &&
    !navigator.userAgent.match(/fxios/i) &&
    !navigator.userAgent.match(/Opera|OPT\//);

declare var heightStatusBar: number;

export const _IS_MOBILE: boolean = (typeof Mobile === "object");

export var SCANED_QR_VALUE: string = "";

export function _LoadAPPInfo() {
    if (_IS_MOBILE) {
        const appInfo = Mobile._LoadAPPInfo();
        if (appInfo) Mobile._OnSetAPPInfo(appInfo);

        _SetSizeWindow(); // Enviar el tamaño de la pantalla

    } else {
        let result = <IAppData>{};

        result.username = localStorage.getItem("username");
        result.password = localStorage.getItem("password");

        //Default App Values
        result.mobileType = 3;// => 1: iOS, 2: Android, 3: Web
        result.APP_VERSION = "no-mobile";

        let uuid = localStorage.getItem("UUID");
        if (!uuid) uuid = "WEB-" + _CreateUUID();
        result.IMEI = uuid;

        OnLoadAPPData(result);
    }
}

async function OnLoadAPPData(result: IAppData) {
    Object.assign(_APP_DATA, result);

    if (result.username && result.password) {
        const userInfo = await authService.getUserInfo();
        if (userInfo) {
            _APP_DATA.userData = userInfo;
            if (_APP_DATA.userData.IdGrupo > 0) {
                _PROXIMIDAD_CTRL._SetSelectedGroup([_APP_DATA.userData.IdGrupo]);
            }
            await OnHashChangeController();

            window.setTimeout(() => {
                PrivacyPolicyModal.ShowIfNeeded();
            }, 150);
        } else {
            _Logout();
        }

    } else {
        if (_GetHashInfo().Path == "login") {
            _LoadUIFromHash("login");
            _NotifyAppReady();
            return;
        }
        _HashAssign("login");
    }
    _NotifyAppReady();
}

export function _OnEnterChat(idGroup: number, idChild: number) {
    if (_IS_MOBILE && _MobileObjectIsDefined()) {
        Mobile?._EnteringChat && Mobile._EnteringChat(idGroup, idChild);
    }
}

export function _OnLeavingChat(idGroup: number, idChild: number) {
    if (_IS_MOBILE && _MobileObjectIsDefined()) {
        Mobile?._LeavingChat && Mobile?._LeavingChat(idGroup, idChild);
    }
}

export function _LoadingProcess(active = LOADING.IsActive()) {
    if (_IS_MOBILE && _MobileObjectIsDefined() && Mobile?._LoadingProcess) {
        Mobile._LoadingProcess(active);
    }
}

export function _SaveUserData(infoUser: any) {
    let info: any = {};
    Object.keys(infoUser).forEach(key => {
        let value = infoUser[key];
        if (value != null && value != undefined) {
            if ((value instanceof Date && Number.isNaN(value.valueOf())))
                return;

            info[key] = value;
        }
    });

    if (_IS_MOBILE) {
        Mobile._SaveUserData(JSON.stringify(info));
    } else {
        localStorage.setItem("username", infoUser.username);
        localStorage.setItem("password", infoUser.password);
        localStorage.setItem("UUID", _APP_DATA.IMEI);
    }

    _APP_DATA.username = infoUser.username;
    _APP_DATA.password = infoUser.password;
    _APP_DATA.userData = infoUser;
}

export function _ShowMessage(msg: string) {
    if (_IS_MOBILE && Mobile && Mobile._ShowMessage) {
        Mobile._ShowMessage(msg);
    } else {
        ShowToast("", msg);
    }
}

export function _ClearHistory() {
    if (_IS_MOBILE) Mobile._ClearHistory();
}

export function _ClearCache() {
    if (_IS_MOBILE) Mobile._ClearCache();
}

export function _SetSizeWindow(): void {
    if (_IS_MOBILE) {
        Mobile._SetSizeWindow(window.innerWidth, window.innerHeight);
    }
}

export function _Logout() {
    DBDelete().then(() => {
        _APP_DATA.username = null;
        _APP_DATA.password = null;

        DataUtilLocalStorage._RemoveSessionData();
        if (_IS_MOBILE) Mobile._Logout();

        _ClearHistory();

        location.reload();
    }).catch((_) => {
        console.log("Error al eliminar bd")
    });
}

export function _SaveImage(urlImage: string, fileName: string) {
    if (_IS_MOBILE) {
        var info = {
            url: urlImage,
            name: fileName
        }
        Mobile._SaveImage(JSON.stringify(info));
    } else
        _DownloadFile(urlImage, fileName);
}

export function _ScanQR() {
    if (_IS_MOBILE) {
        Mobile._ScanQR();
    } else {
        console.log("Función no disponible.")
    }
}
export function _GetUserAgent() {
    let sBrowser, sUsrAg = navigator.userAgent;

    if (sUsrAg.indexOf("Chrome") > -1) {
        sBrowser = "Google Chrome";
    } else if (sUsrAg.indexOf("Safari") > -1) {
        sBrowser = "Apple Safari";
    } else if (sUsrAg.indexOf("Opera") > -1) {
        sBrowser = "Opera";
    } else if (sUsrAg.indexOf("Firefox") > -1) {
        sBrowser = "Mozilla Firefox";
    } else if (sUsrAg.indexOf("MSIE") > -1) {
        sBrowser = "Microsoft Internet Explorer";
    } else {
        sBrowser = "UserAgent Unknow";
    }

    return sBrowser;
}

export let _MOBILE_INSETS: IMobileInsets = { top: 0, left: 0, bottom: 0, right: 0 };

// ****************************************************************
// BUILD MOBILE OBJECT
// ****************************************************************

let _MobileSetKeyboardSize: (bodyTranslateY: number, keyboardHeight: number) => void;
const isMobileKeyboardSupported = () => _MobileSetKeyboardSize && _MobileObjectIsDefined();

export function _InputBlurReapplyKeyboardSize() {
    if (!isMobileKeyboardSupported()) return;
    setTimeout(() => {
        const activeIsInput = document.activeElement instanceof HTMLInputElement || document.activeElement instanceof HTMLTextAreaElement;
        if (!activeIsInput) {
            _MobileSetKeyboardSize(0, 0);
        }
    });
}

if (_IS_MOBILE) {
    Mobile._OnSetAPPInfo = (resData: string) => {
        var info = JSON.parse(resData);
        OnLoadAPPData(info);
    }

    Mobile._SetKeyBoardSize = function (bodyTranslateY: number, keyboardHeight: number) {
        _MobileSetKeyboardSize(bodyTranslateY, keyboardHeight);
    }

    let __OnFocusIn: typeof document.onfocus;
    _MobileSetKeyboardSize = (bodyTranslateY: number, keyboardHeight: number) => setTimeout(() => {
        if (_IS_SAFARI_NAVIGATOR) { // iOS no necesita esta función
            return;
        }
        // document.body.style.transform = "";
        const initActive = document.activeElement;
        let bodyTranslateYFinal = bodyTranslateY;
        if (bodyTranslateY != 0 && initActive) {
            const resolveLimitElementsDefault = 30;
            const resolveLimitElements = (initActive.hasAttribute("keyboard_limit") ? Number(initActive.getAttribute("keyboard_limit") || 0) : resolveLimitElementsDefault);
            const { y, height } = initActive.getBoundingClientRect();
            const { bottom: bodyBottom } = document.body.getBoundingClientRect();
            bodyTranslateYFinal -= (bodyBottom - (y + height + resolveLimitElements));
            if (bodyTranslateYFinal < 0) bodyTranslateYFinal = 1;
        }
        if (bodyTranslateYFinal > 0) {
            document.body.style.transition = "transition .5s";
            document.body.style.transform = "translateY(-" + bodyTranslateYFinal + "px)";
            // console.debug(document.body.style.transform);
            if (__OnFocusIn) {
                document.removeEventListener("focusin", __OnFocusIn);
            }
            __OnFocusIn = () => setTimeout(() => {
                const { activeElement } = document;
                const activeIsInput = activeElement instanceof HTMLInputElement || activeElement instanceof HTMLTextAreaElement;
                // console.warn("focusin", activeElement, activeIsInput);
                if (activeIsInput && initActive != activeElement) {
                    _MobileSetKeyboardSize(bodyTranslateY, keyboardHeight);
                }
            });
            document.addEventListener("focusin", __OnFocusIn);
        }
        else {
            document.body.style.transition = "transition .5s";
            document.body.style.transform = "translateY(0)";

            document.removeEventListener("focusin", __OnFocusIn);
            __OnFocusIn = null;
        }

        if (keyboardHeight > 0) {
            document.body.classList.add("keyboard-active");
        } else {
            document.body.classList.remove("keyboard-active");
        }

        // dispatch event
        _CURRENT_MOBILEKEYBOARD.BodyTranslateY = bodyTranslateYFinal;
        _CURRENT_MOBILEKEYBOARD.KeyboardHeight = keyboardHeight;
        const evt = new CustomEvent<KeyboardSizeChangeEvent["detail"]>("keyboardsizechange", {
            bubbles: true,
            cancelable: true,
            detail: { ..._CURRENT_MOBILEKEYBOARD },
        })
        document.dispatchEvent(evt);
    }, 10);

    Mobile._OnBack = function () {
        if (LOADING.IsActive()) {
            history.back();
        }
    }

    Mobile._OnSetQRValue = function (value: string) {
        SCANED_QR_VALUE = value;

        _HashAssign("qrview");
    }

    Mobile._SendInsetsToWeb = function (safeViewInsets: IMobileInsets) {
        document.body.style.setProperty('--inset-safe-area-top', safeViewInsets.top + 'px');
        document.body.style.setProperty('--inset-safe-area-bottom', safeViewInsets.bottom + 'px');
        document.body.style.setProperty('--inset-safe-area-left', safeViewInsets.left + 'px');
        document.body.style.setProperty('--inset-safe-area-right', safeViewInsets.right + 'px');
        document.body.style.setProperty('--inset-safe-area', `${safeViewInsets.top}px ${safeViewInsets.right}px ${safeViewInsets.bottom}px ${safeViewInsets.left}px`);
        _MOBILE_INSETS = { ..._MOBILE_INSETS, ...safeViewInsets };
        document.dispatchEvent(new CustomEvent<MobileInsetChangeEvent["detail"]>("mobileinsetchange", {
            detail: { ..._MOBILE_INSETS },
        }));
        setTimeout(() => {
            console.warn("Mobile Safe Area Insets:", safeViewInsets);
        }, 3000);
    }

    const forceConsultGroupIds: Set<number> = new Set();
    let forceConsultOpenOnResult = false;
    let forcedConsultTimer: NodeJS.Timeout | null = null;
    const triggerProximity: IMobile["_TriggerProximity"] = async function (options: { idGrupo: number, forceConsult?: boolean, forceOpen?: boolean }) {
        if (!options) return;
        const groupChanged = (options.idGrupo > 0 && options.idGrupo !== _APP_DATA.userData?.IdGrupo);
        if (groupChanged) {
            LOADING.Show();
            await new Promise<void>(resolve => {
                const groupChangeListener = (_: GroupChangeEvent) => {
                    groupContext.removeOnGroupChangeEventListener(groupChangeListener);
                    LOADING.Dismiss();
                    setTimeout(() => resolve(), 100);
                }
                groupContext.addOnGroupChangeEventListener(groupChangeListener);
                _HashReplace("#home--groupid=" + options.idGrupo as THashPath);

                setTimeout(() => {
                    groupContext.removeOnGroupChangeEventListener(groupChangeListener);
                    LOADING.Dismiss();
                    resolve();
                }, 10000 /* timeout: 10 segundos */);
            });
        }
        if (options.idGrupo > 0) {
            _PROXIMIDAD_CTRL._AddSelectedGroup(options.idGrupo);
        }
        if (options.forceOpen) {
            _PROXIMIDAD_CTRL._OpenModal();
        }
        if (options.forceConsult) {
            forceConsultOpenOnResult = options.forceOpen || false;
            if (forcedConsultTimer) {
                clearTimeout(forcedConsultTimer);
                const idG = Math.abs(options.idGrupo || 0);
                !!idG && forceConsultGroupIds.add(idG);
            }
            forcedConsultTimer = setTimeout(() => {
                if (forceConsultGroupIds.size > 0) {
                    _PROXIMIDAD_CTRL._ForceConsult(forceConsultOpenOnResult, [...forceConsultGroupIds]);
                    forceConsultGroupIds.clear();
                }
                forcedConsultTimer = null;
                forceConsultOpenOnResult = false;
            }, 1100);
        }
    }

    Mobile._TriggerProximity = (...args) => {
        triggerProximity(...args);
    };
}

export function _NotifyAppReady() {
    if (_IS_MOBILE && _MobileObjectIsDefined()) {
        Mobile?._WebAppReady && Mobile._WebAppReady();
    }
}

export function _UpdateCurrentHashViewMobile(hash: THashPath) {
    if (_IS_MOBILE && _MobileObjectIsDefined()) {
        Mobile?._HashViewChanged && Mobile._HashViewChanged(hash);
    }
}

export function _EnqueuePhotoEventForBunchUpload(payload: PhotoEventUploadPayload) {
    if (_IS_MOBILE && _MobileObjectIsDefined()) {
        Mobile._EnqueuePhotoEventForBunchUpload && Mobile._EnqueuePhotoEventForBunchUpload(JSON.stringify(payload));
    }
}

export function _CanUploadInBackground(): boolean {
    if (!_IS_MOBILE || !_MobileObjectIsDefined()) return false;
    if ((window as any).webkit?.messageHandlers) {
        return !!(window as any).webkit?.messageHandlers._EnqueuePhotoEventForBunchUpload;
    }

    if (typeof Mobile._EnqueuePhotoEventForBunchUpload === 'function') {
        return true;
    }

    return false;
}
